import { Behavior } from "../../base/Behavior";
import { TableRowToolsViewer } from "./TableRowToolsViewer";
import { PanelProps } from "../panel/PanelProps";
import { VerticalAlignment } from "@mcleod/core";
import { Component } from "../../base/Component";
import { Button } from "../button/Button";

export class TableRowToolsViewerBehavior extends Behavior {
    protected constructor() {
        super();
    }

    get defaultProps(): Partial<PanelProps> {
        return {
            rowBreakDefault: false,
            borderRadius: 20,
            backgroundColor: "subtle.lightest",
            verticalAlign: VerticalAlignment.CENTER
        }
    }

    addTools(viewer: TableRowToolsViewer, ellipsisButton: Button, ...tools: Component[]): void {
        tools.forEach(tool => {
            tool.margin = this.toolMargin;
            tool.padding = this.toolPadding;
            viewer.add(tool);
        });
        viewer.add(ellipsisButton);
    }

    get toolPadding(): number {
        return 0;
    }

    get toolMargin(): number {
        return 4;
    }

    get type(): string {
        return "TableRowToolsViewer";
    }
}

TableRowToolsViewerBehavior.register();
